import Vue from 'vue';
import Router, { Route }  from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue'),
    },
    {
      path: '/reports',
      name: 'reports',
      component: () => import('./views/ManagementReport.vue'),
    },
    {
      path: '/master/Project',
      components: {
        default: () => import('./views/project.vue'),
        sidebar: () => import('./sidebars/master.vue'),
      },
    },
    {
      path: '/master/Category_BackLog',
      components: {
        default: () => import('./views/category.vue'),
        sidebar: () => import('./sidebars/master.vue'),
      },
    },
    {
      path: '/system/User',
      components: {
        sidebar: () => import('./sidebars/system.vue'),
        default: () => import('@/agiles/vues/user.vue'),
      },
    },
    {
      path: '/system/Group',
      components: {
        sidebar: () => import('./sidebars/system.vue'),
        default: () => import('@/agiles/vues/group.vue'),
      },
    },
    {
      path: '/system/GroupMember',
      components: {
        sidebar: () => import('./sidebars/system.vue'),
        default: () => import('@/agiles/vues/groupMember.vue'),
      },
    },
    {
      path: '/system/Permission',
      components: {
        sidebar: () => import('./sidebars/system.vue'),
        default: () => import('@/agiles/vues/permission.vue'),
      },
    },
    {
      path: '/system/Workflow',
      components: {
        sidebar: () => import('./sidebars/system.vue'),
        default: () => import('@/agiles/vues/workflow.vue'),
      },
    },
    {
      path: '/system/WorkflowPermission',
      components: {
        sidebar: () => import('./sidebars/system.vue'),
        default: () => import('@/agiles/vues/workflowPermission.vue'),
      },
      props: { default: (route : Route) =>({workflow:route.query.workflow}), sidebar: false }        
    },
    {
      path: '/system/WorkflowAction',
      components: {
        sidebar: () => import('./sidebars/system.vue'),
        default: () => import('@/agiles/vues/workflowAction.vue'),
      },
    },
    {
      path: '/system/Word',
      components: {
        sidebar: () => import('./sidebars/system.vue'),
        default: () => import('@/agiles/vues/word.vue'),
      },
    },
    {
      path: '/system/CustomTemplate',
      components: {
        sidebar: () => import('./sidebars/system.vue'),
        default: () => import('@/agiles/vues/customTemplate.vue'),
      },
    },
    {
      path: '/system/ReportTemplate',
      components: {
        sidebar: () => import('./sidebars/system.vue'),
        default: () => import('@/agiles/vues/reportTemplate.vue'),
      },
      props: { default: (route : Route) =>({id:route.query.id}), sidebar: false }                  
    },
    {
      path: '/system/ReportLayout',
      components: {
        sidebar: () => import('./sidebars/system.vue'),
        default: () => import('@/agiles/vues/reportLayout.vue'),
      },
      props: { default: (route : Route) =>({templateId:route.query.templateId}), sidebar: false }                
    },
    {
      path: '/system/ECSetting',
      components: {
        sidebar: () => import('./sidebars/system.vue'),
        default: () => import('./views/Master/ECSetting.vue'),
      },          
    },        
    {
      path: '/system/ECCommodity',
      components: {
        sidebar: () => import('./sidebars/system.vue'),
        default: () => import('./views/Master/ECCommodity.vue'),
      },          
    },      
    {
      path: '/system/BatchSchedule',
      components: {
        sidebar: () => import('./sidebars/system.vue'),
        default: () => import('@/agiles/vues/batchSchedule.vue'),
      },          
    },    
    {
      path: '/system/Subscription',
      components: {
        sidebar: () => import('./sidebars/system.vue'),
        default: () => import('@/agiles/vues/subscription.vue'),
      },
    },    
    {
      path: '/system/PartneredTenant',
      components: {
        sidebar: () => import('./sidebars/system.vue'),
        default: () => import('./views/Master/PartneredTenant.vue'),
      },
    },    
    {
      path: '/system/PartneredUser',
      components: {
        sidebar: () => import('./sidebars/system.vue'),
        default: () => import('./views/Master/PartneredUser.vue'),
      },
    },    
    // {
    //   path: '/system/Audit',
    //   components: {
    //     sidebar: () => import('./sidebars/system.vue'),
    //     default: () => import('@/agiles/vues/audit.vue'),
    //   },
    // },        
    {
      path: '/system/FileLayout',
      components: {
        sidebar: () => import('./sidebars/system.vue'),
        default: () => import('@/agiles/vues/fileLayout.vue'),
      },
    },      
    {
      path: '/system/Topics',
      components: {
        sidebar: () => import('./sidebars/system.vue'),
        default: () => import('@/agiles/vues/topics.vue'),
      },
      props: { default: (route : Route) =>({isEditMode:true}), sidebar: false }        
    },        
    {
      path: '/system/Audit',
      components: {
        sidebar: () => import('./sidebars/system.vue'),
        default: () => import('@/agiles/vues/audit.vue'),
      },
    },        
    {
      path: '/system/FileLayout',
      components: {
        sidebar: () => import('./sidebars/system.vue'),
        default: () => import('@/agiles/vues/fileLayout.vue'),
      },
    },      
    {
      path: '/system/Topics',
      components: {
        sidebar: () => import('./sidebars/system.vue'),
        default: () => import('@/agiles/vues/topics.vue'),
      },
      props: { default: (route : Route) =>({isEditMode:true}), sidebar: false }        
    },        
    {
      path: '/setting/Personal',
      components: {
        sidebar: () => import('@/agiles/sidebars/personal.vue'),
        default: () => import('@/agiles/vues/personal.vue'),
      },
    },
    {
      path: '/setting/Favorite',
      components: {
        sidebar: () => import('./sidebars/operation.vue'),
        default: () => import('@/agiles/vues/favorite.vue'),
      },
    },
    // {
    //   path: '/operation/Info',
    //   components: {
    //     sidebar: () => import('./sidebars/operation.vue'),
    //     default: () => import('./views/Operation/Info.vue'),
    //   },
    // },    
    {
      path: '/operation/SystemLog',
      components: {
        sidebar: () => import('./sidebars/operation.vue'),
        default: () => import('@/agiles/vues/systemLog.vue'),
      },
      props: { default: (route : Route) =>({id:route.query.id}), sidebar: false }                   
    },
    {
      path: '/operation/Audit',      
      components: {
        sidebar: () => import('./sidebars/operation.vue'),
        default: () => import('@/agiles/vues/audit.vue'),
      },
    },    
    {
      path: '/operation/MonthClose',
      components: {
        sidebar: () => import('./sidebars/operation.vue'),
        default: () => import('./views/Operation/MonthClose.vue'),
      },
    },            
    {
      path: '/operation/Topics',
      components: {      
        sidebar: () => import('./sidebars/operation.vue'),
        default: () => import('@/agiles/vues/topics.vue'),
      },
      props: { default: (route : Route) =>({id:route.query.id,isAdminQuery:route.query.isAdmin}), sidebar: false }           
    },    
    {
      path: '/project/matter',
      components: {
        sidebar: () => import('./sidebars/project.vue'),
      },
      props: { default: (route : Route) =>({matterId:route.query.matterId}), sidebar: false }        
    },
    {
      path: '/project/task',
      components: {
        default: () => import('./views/Task.vue'),
        sidebar: () => import('./sidebars/project.vue'),
      },
      props: { default: (route : Route) =>({taskId:route.query.taskId}), sidebar: false }             
    },
    {
      path: '/master/Segment',
      components: {
        default: () => import('./views/Master/Segment.vue'),
        sidebar: () => import('./sidebars/master.vue'),
      },
      props: { default: (route : Route) =>({auditNo:route.query.auditNo}), sidebar: false }
    },
    {
      path: '/master/Commodity',
      components: {
        default: () => import('./views/Master/Commodity.vue'),
        sidebar: () => import('./sidebars/master.vue'),
      },
      props: { default: (route : Route) =>({auditNo:route.query.auditNo}), sidebar: false }
    },
    {
      path: '/master/Conversion',
      components: {
        default: () => import('./views/Master/Conversion.vue'),
        sidebar: () => import('./sidebars/master.vue'),
      },
      props: { default: (route : Route) =>({auditNo:route.query.auditNo, commodity:route.query.commodity}), sidebar: false }
    },
    {
      path: '/master/Price',
      components: {
        default: () => import('./views/Master/Price.vue'),
        sidebar: () => import('./sidebars/master.vue'),
      },
      props: { default: (route : Route) =>({auditNo:route.query.auditNo, commodity:route.query.commodity}), sidebar: false }
    },
    {
      path: '/master/SKU',
      components: {
        default: () => import('./views/Master/SKU.vue'),
        sidebar: () => import('./sidebars/master.vue'),
      },
      props: { default: (route : Route) =>({auditNo:route.query.auditNo, commodity:route.query.commodity}), sidebar: false }
    },
    {
      path: '/master/Counterpart',
      components: {
        default: () => import('./views/Master/Counterpart.vue'),
        sidebar: () => import('./sidebars/master.vue'),
      },
      props: { default: (route : Route) =>({auditNo:route.query.auditNo}), sidebar: false }
    },
    {
      path: '/master/Category',
      components: {
        default: () => import('./views/Master/Category.vue'),
        sidebar: () => import('./sidebars/master.vue'),
      },
      props: { default: (route : Route) =>({auditNo:route.query.auditNo}), sidebar: false }
    },
    {
      path: '/master/Account',
      components: {
        default: () => import('./views/Master/Account.vue'),
        sidebar: () => import('./sidebars/master.vue'),
      },
      props: { default: (route : Route) =>({auditNo:route.query.auditNo}), sidebar: false }
    },
    {
      path: '/master/TaxCode',
      components: {
        default: () => import('./views/Master/TaxCode.vue'),
        sidebar: () => import('./sidebars/master.vue'),
      },
      props: { default: (route : Route) =>({auditNo:route.query.auditNo}), sidebar: false }
    },
    {
      path: '/master/ExchangeRate',
      components: {
        default: () => import('./views/Master/ExchangeRate.vue'),
        sidebar: () => import('./sidebars/master.vue'),
      },
      props: { default: (route : Route) =>({auditNo:route.query.auditNo}), sidebar: false }
    },
    {
      path: '/master/Currency',
      components: {
        default: () => import('./views/Master/Currency.vue'),
        sidebar: () => import('./sidebars/master.vue'),
      },
      props: { default: (route : Route) =>({auditNo:route.query.auditNo}), sidebar: false }
    },
    {
      path: '/master/TenantSettings',
      components: {
        default: () => import('./views/Master/TenantSettings.vue'),
        // sidebar: () => import('./sidebars/master.vue'),
        sidebar: () => import('./sidebars/system.vue'),        
      },
    },
    // {
    //   path: '/master/SubAccount',
    //   components: {
    //     default: () => import('./views/Master/SubAccount.vue'),
    //     sidebar: () => import('./sidebars/master.vue'),
    //   },
    // },    
    {
      path: '/master/ShelfNo',
      components: {
        default: () => import('./views/Master/ShelfNo.vue'),
        sidebar: () => import('./sidebars/master.vue'),
      },
      props: { default: (route : Route) =>({auditNo:route.query.auditNo,commodity:route.query.commodity}), sidebar: false }
    },
    {
      path: '/master/Assembly',
      components: {
        default: () => import('./views/Master/Assembly.vue'),
        sidebar: () => import('./sidebars/master.vue'),
      },
      props: { default: (route : Route) =>({auditNo:route.query.auditNo ,id:route.query.id}), sidebar: false }
    },
    {
      path: '/master/Component',
      components: {
        default: () => import('./views/Master/Component.vue'),
        sidebar: () => import('./sidebars/master.vue'),
      },
      props: { default: (route : Route) =>({auditNo:route.query.auditNo, assemblyId:route.query.assemblyId}), sidebar: false }
    },        
    {
      path: '/master/BankAccount',
      components: {
        default: () => import('./views/Master/BankAccount.vue'),
        sidebar: () => import('./sidebars/master.vue'),
      },
      props: { default: (route : Route) =>({auditNo:route.query.auditNo}), sidebar: false }
    },        
    {
      path: '/sales/SalesOrder',
      components: {
        default: () => import('./views/Transaction/SalesOrder.vue'),
        sidebar: () => import('./sidebars/sales.vue'),
      },
      props: { default: (route : Route) =>({orderNo:route.query.orderNo}), sidebar: false }
    },
    {
      path: '/sales/SalesOrderItem',
      components: {
        default: () => import('./views/Transaction/SalesOrderItem.vue'),
        sidebar: () => import('./sidebars/sales.vue'),
      },
      props: { default: (route : Route) =>({
        orderNo:route.query.orderNo, 
        orderItemNo:route.query.orderItemNo,
        commodity:route.query.commodity,
        sku:route.query.sku,
        state: route.query.state,
        scheduledDeliveryDateTo:route.query.scheduledDeliveryDateTo,        
        }), sidebar: false },
    },
    {
      path: '/sales/SalesDelivery',
      components: {
        default: () => import('./views/Transaction/SalesDelivery.vue'),
        sidebar: () => import('./sidebars/sales.vue'),
      },
      props: { default: (route : Route) =>({deliveryNo:route.query.deliveryNo, pickingNo:route.query.pickingNo}), sidebar: false }
    },
    {
      path: '/sales/SalesPicking',
      components: {
        default: () => import('./views/Transaction/SalesPicking.vue'),
        sidebar: () => import('./sidebars/sales.vue'),
      },
      props: { default: (route : Route) =>({pickingNo:route.query.pickingNo}), sidebar: false }
    },    
    {
      path: '/sales/SalesDeliveryItem',
      components: {
        default: () => import('./views/Transaction/SalesDeliveryItem.vue'),
        sidebar: () => import('./sidebars/sales.vue'),
      },
      props: { default: (route : Route) =>({
        deliveryNo:route.query.deliveryNo,
        orderItemNo:route.query.orderItemNo,
        deliveryItemNo:route.query.deliveryItemNo,
        purchaseDeliveryItemNo:route.query.purchaseDeliveryItemNo,
        isInvoiceItem:false,
        commodity:route.query.commodity,
        sku:route.query.sku,
        state: route.query.state,
        deliveryDateTo:route.query.deliveryDateTo,
        deliveryDateFrom:route.query.deliveryDateFrom,        
      }), sidebar: false }
    },
    {
      path: '/sales/InvoiceItem',
      components: {
        default: () => import('./views/Transaction/SalesDeliveryItem.vue'),
        sidebar: () => import('./sidebars/sales.vue'),
      },
      props: { default: (route : Route) =>({
        deliveryNo:route.query.deliveryNo, 
        orderItemNo:route.query.orderItemNo, 
        deliveryItemNo:route.query.deliveryItemNo,
        invoiceNo:route.query.invoiceNo, 
        isInvoiceItem:true
      }), sidebar: false }
    },
    {
      path: '/sales/SalesCharge',
      components: {
        default: () => import('./views/Transaction/SalesCharge.vue'),
        sidebar: () => import('./sidebars/sales.vue'),
      },
      props: { default: (route : Route) =>({chargeNo:route.query.chargeNo}), sidebar: false } 
    },    
    {
      path: '/sales/CarryOverInvoice',
      components: {
        default: () => import('./views/Transaction/CarryOverInvoice.vue'),
        sidebar: () => import('./sidebars/sales.vue'),
      },
      props: { default: (route : Route) =>({invoiceNo:route.query.invoiceNo}), sidebar: false }
    },
    {
      path: '/sales/AloneInvoice',
      components: {
        default: () => import('./views/Transaction/AloneInvoice.vue'),
        sidebar: () => import('./sidebars/sales.vue'),
      },
      props: { default: (route : Route) =>({invoiceNo:route.query.invoiceNo}), sidebar: false }
    },

    {
      path: '/sales/SalesCharge',
      components: {
        default: () => import('./views/Transaction/SalesCharge.vue'),
        sidebar: () => import('./sidebars/sales.vue'),
      },
    },
    {
      path: '/sales/ProjectItem',
      components: {
        default: () => import('./views/Transaction/ProjectItem.vue'),
        sidebar: () => import('./sidebars/sales.vue'),
      },
      props: { default: (route : Route) =>({projectItemNo:route.query.projectItemNo}), sidebar: false }
    },    
    {
      path: '/purchase/PurchaseOrder',
      components: {
        default: () => import('./views/Transaction/PurchaseOrder.vue'),
        sidebar: () => import('./sidebars/purchase.vue'),
      },
      props: { default: (route : Route) =>({orderNo:route.query.orderNo}), sidebar: false }
    },
    {
      path: '/purchase/PurchaseOrderItem',
      components: {
        default: () => import('./views/Transaction/PurchaseOrderItem.vue'),
        sidebar: () => import('./sidebars/purchase.vue'),
      },
      props: { default: (route : Route) =>({
        orderNo:route.query.orderNo, 
        salesOrderItemNo:route.query.salesOrderItemNo, 
        orderItemNo:route.query.orderItemNo,
        commodity:route.query.commodity,
        sku:route.query.sku,
        state: route.query.state,
        scheduledDeliveryDateTo:route.query.scheduledDeliveryDateTo,        
        }), sidebar: false }
    },
    {
      path: '/purchase/PurchaseDelivery',
      components: {
        default: () => import('./views/Transaction/PurchaseDelivery.vue'),
        sidebar: () => import('./sidebars/purchase.vue'),
      },
      props: { default: (route : Route) =>({deliveryNo:route.query.deliveryNo}), sidebar: false }
    },
    {
      path: '/purchase/PurchaseDeliveryItem',
      components: {
        default: () => import('./views/Transaction/PurchaseDeliveryItem.vue'),
        sidebar: () => import('./sidebars/purchase.vue'),
      },
      props: { default: (route : Route) =>({
        deliveryNo:route.query.deliveryNo,
        deliveryItemNo:route.query.deliveryItemNo,
        orderNo:route.query.orderNo,
        orderItemNo:route.query.orderItemNo,
        commodity:route.query.commodity,
        sku:route.query.sku,
        state: route.query.state,
        deliveryDateTo:route.query.deliveryDateTo,        
        deliveryDateFrom:route.query.deliveryDateFrom,                
      }), sidebar: false }
    },
    {
      path: '/purchase/PurchaseInvoice',
      components: {
        default: () => import('./views/Transaction/PurchaseInvoice.vue'),
        sidebar: () => import('./sidebars/purchase.vue'),
      },
      props: { default: (route : Route) =>({invoiceNo:route.query.invoiceNo}), sidebar: false }      
    },    
    {
      path: '/purchase/PurchaseCharge',
      components: {
        default: () => import('./views/Transaction/PurchaseCharge.vue'),
        sidebar: () => import('./sidebars/purchase.vue'),
      },
      props: { default: (route : Route) =>({chargeNo:route.query.chargeNo}), sidebar: false } 
    },
    {
      path: '/journal/StockBalance',
      components: {
        default: () => import('./views/Journal/StockBalance.vue'),
        sidebar: () => import('./sidebars/journal.vue'),
      },
      props: { default: (route : Route) =>({commodity:route.query.commodity,sku:route.query.sku, closingDate:route.query.closingDate}), sidebar: false }       
    },
    {
      path: '/journal/StockReplenishmentCommodity',
      components: {
        default: () => import('./views/Journal/StockReplenishmentCommodity.vue'),
        sidebar: () => import('./sidebars/journal.vue'),
      },
      props: { default: (route : Route) =>({
        baseDate:route.query.baseDate,
        supplierCode:route.query.supplierCode,
        replenishmentType:route.query.replenishmentType,
        isShortage:route.query.isShortage
      }), sidebar: false }       
    },
    {
      path: '/journal/StockTaking',
      components: {
        default: () => import('./views/Journal/StockTaking.vue'),
        sidebar: () => import('./sidebars/journal.vue'),
      },
      props: { default: (route : Route) =>({stockTakingNo:route.query.stockTakingNo}), sidebar: false } 
    },
    {
      path: '/journal/StockTakingItem',
      components: {
        default: () => import('./views/Journal/StockTakingItem.vue'),
        sidebar: () => import('./sidebars/journal.vue'),
      },
      props: { default: (route : Route) =>({stockTakingNo:route.query.stockTakingNo,stockTakingItemNo:route.query.stockTakingItemNo}), sidebar: false } 
    },
    {
      path: '/journal/StockSchedule',
      components: {
        default: () => import('./views/Journal/StockSchedule.vue'),
        sidebar: () => import('./sidebars/journal.vue'),
      },
    },      
    {
      path: '/journal/StockRelocation',
      components: {
        default: () => import('./views/Journal/StockRelocation.vue'),
        sidebar: () => import('./sidebars/journal.vue'),
      },
      props: { default: (route : Route) =>({stockRelocationNo:route.query.stockRelocationNo}), sidebar: false } 
    },      
    {
      path: '/journal/StockRelocationItem',
      components: {
        default: () => import('./views/Journal/StockRelocationItem.vue'),
        sidebar: () => import('./sidebars/journal.vue'),
      },
      props: { default: (route : Route) =>({stockRelocationNo:route.query.stockRelocationNo,stockRelocationItemNo:route.query.stockRelocationItemNo}), sidebar: false } 
    },        
    {
      path: '/journal/StockTransfer',
      components: {
        default: () => import('./views/Journal/StockTransfer.vue'),
        sidebar: () => import('./sidebars/journal.vue'),
      },
      props: { default: (route : Route) =>({stockTransferNo:route.query.stockTransferNo}), sidebar: false } 
    },      
    {
      path: '/journal/StockTransferItem',
      components: {
        default: () => import('./views/Journal/StockTransferItem.vue'),
        sidebar: () => import('./sidebars/journal.vue'),
      },
      props: { default: (route : Route) =>({stockTransferNo:route.query.stockTransferNo,stockTransferItemNo:route.query.stockTransferItemNo}), sidebar: false } 
    },               
    {
      path: '/cash/Deposit',
      components: {
        default: () => import('./views/Cash/ReceivePayment.vue'),
        sidebar: () => import('./sidebars/cash.vue'),
      },
      props: { default: (route : Route) =>({paymentNo:route.query.paymentNo}), sidebar: false }
    },    
    {
      path: '/cash/Withdrawal',
      components: {
        default: () => import('./views/Cash/SendPayment.vue'),
        sidebar: () => import('./sidebars/cash.vue'),
      },
      props: { default: (route : Route) =>({paymentNo:route.query.paymentNo}), sidebar: false }
    },    
    // {
    //   path: '/cash/BankAccount',
    //   components: {
    //     default: () => import('./views/Cash/BankAccount.vue'),
    //     sidebar: () => import('./sidebars/cash.vue'),
    //   },
    // },       
    // {
    //   path: '/cash/BankTransfer',
    //   components: {
    //     default: () => import('./views/Cash/BankTransfer.vue'),
    //     sidebar: () => import('./sidebars/cash.vue'),
    //   },
    // },           
    {
      path: '/cash/Journal',
      components: {
        default: () => import('./views/Cash/Journal.vue'),
        sidebar: () => import('./sidebars/cash.vue'),
      },
    },               
    // {
    //   path: '/cash/PaymentDetails',
    //   components: {
    //     default: () => import('./views/Cash/PaymentDetails.vue'),
    //     sidebar: () => import('./sidebars/cash.vue'),
    //   },
    // },         
  ],
});
